/**
 * Whether SaaS subscription billing is enforced for the company.
 * The backend sends `billingEnabled` on /api/company/my-company. A missing value
 * (older backend) is treated as enabled so behaviour is unchanged until the
 * backend reports FREE mode.
 */
const isBillingEnabled = (company) => company?.billingEnabled !== false;

export default isBillingEnabled;
